import isNull from './is-null.js';
import isUndefined from './is-undefined.js';
import isNumber from './is-number.js';

/**
 * @func isDate
 * @param {object} value - the input of the function.
 * @return {boolean}
 * @desc Checks that the input is a date object
 * ```js
 * const myDate = new Date();
 * isDate(myDate);
 * // returns true
 * ```
 * @memberof module:TypeCheck
 * @instance
 */
function isDate(value) {
    if (isNull(value) || isUndefined(value) || isNumber(value))
        return false;
    return value instanceof Date && value.toString() !== 'Invalid Date';
}

export { isDate as default };
